import { NgModule } from '@angular/core';
import { ApiModule } from '@monsido/modules/endpoints/api/api.module';

@NgModule({
    imports: [ApiModule],
    exports: [ApiModule],
    declarations: [],
    providers: [],
})
export class EndpointsModule {}
